import { Component, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CreateFormFrequencyTimeStore } from './create-form-frequency-time.store';
import { TimesMockStore } from "src/app/shared/store-mocks/times.store";

@Component({
  selector: 'app-create-form-frequency-time',
  templateUrl: './create-form-frequency-time.component.html',
  styleUrls: ['./create-form-frequency-time.component.scss'],
  providers: [CreateFormFrequencyTimeStore, TimesMockStore]
})
export class CreateFormFrequencyTimeComponent implements OnInit {

  constructor(
    public ngControl: NgControl,
    private store: CreateFormFrequencyTimeStore
  ) {
    ngControl.valueAccessor = this;
  }

  // vm$ = this.store.vm$
  value: any = ''

  onChange: any = () => {}
  onTouch: any = () => {}

  times$ = this.store.entities$

  ngOnInit(): void {


  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }


  modelChange(value: string){
    if(!this.ngControl.touched){
      this.onTouch()
    }

    this.onChange(value)
  }

  onValueChange(event: any){
    this.modelChange(event)
  }
}
